export const indicatorMetaBase = process.env.REACT_APP_INDICATOR_META_BASE;
export const geoserverBase = process.env.REACT_APP_GEOSERVER_BASE;
export const awsServerBase = process.env.REACT_APP_AWS_SERVER_BASE;
export const aqfxServerBase = process.env.REACT_APP_AQFX_SERVER_BASE;
export const fmsServerBase = process.env.REACT_APP_FMS_SERVER_BASE;
export const emapServerBase = process.env.REACT_APP_EMAP_SERVER_BASE;
export const urlBase = process.env.REACT_APP_URL_BASE;
export const disableAuth = 'true' === process.env.REACT_APP_DISABLE_AUTH;
export const verboseLogging = 'true' === process.env.REACT_APP_VERBOSE_LOGGING;



// WEBPACK FOOTER //
// ./src/config/environment.js